import React, { useState, useEffect, useRef } from 'react';
import { Area } from '@antv/g2plot';
import i18next from 'i18next';
import { GetIcon } from 'datastake-daf/dist/components';
import moment from 'moment';
import { getRiskGradient } from '../../../helper';
import styled from 'styled-components';
import { colors, labelsNoTranslation } from './riskEvolution';
import { useTranslation } from 'react-i18next';

const RiskTrendStyle = styled.div`
  .custom-risk-trend-tooltip {
    display: flex;
    padding: 8px;
    gap: 10px;

    .cont {
      display: flex;
      flex-direction: column;
      justify-content: center;

      label {
        margin-bottom: 0px;
        font-weight: 500;
      }
    }

    .round-score {
      width: 28px;
      height: 28px;
      border-radius: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;

      label {
        font-weight: 600;
        color: white;
      }
    }

    .label {
      font-weight: 600;
    }
  }

  .graph-cont {
    height: 300px;
  }
`;

export default function RiskTrend({
  data = [
    {
      "key": 1,
      "date": "2010-01",
      "Score": 5
    },
    {
      "key": 2,
      "date": "2010-02",
      "Score": 5
    },
    {
      "key": 3,
      "date": "2010-03",
      "Score": 5
    },
  ],
  isSubGroup = false,
}) {
  const [mainGraph, setMainGraph] = useState(null);
  const container = useRef();
  const { t } = useTranslation();

  useEffect(() => {
    const sorted = JSON.parse(JSON.stringify(data)).sort((a, b) => b.Score - a.Score);
    const maxScore = sorted.length ? sorted[0].Score : 0;
    const roundScore = Math.round(maxScore);
    if (mainGraph) {
      mainGraph.update({
        data,
        areaStyle: () => {
          let fill = `l(270) ${getRiskGradient(roundScore)}`;
          return {
            fill,
          };
        },
        tooltip: {
          showTitle: false,
          formatter: (datum) => {
            return { name: moment(datum.date).format('YYYY-MM-DD'), value: datum.Score };
          },
          customContent: (title, data) => {
            if (Array.isArray(data)) {
              const item = data[0];
              if (item && item.data) {
                const { Score, date } = item.data;
                const rounded = Math.round(Score);
                const label = labelsNoTranslation[rounded];
                const color = colors[rounded];

                return `<div class="custom-risk-trend-tooltip">
                <div class="cont">
                  <label>${moment(date).format('DD MMM YYYY')}</label>
                </div>
                <div class="cont">
                  <div class="round-score" style="background: ${color}">
                    <label>${Number(Score).toFixed(1)}</label>
                  </div>
                </div>
                <div class="cont">
                  <label class="label" style="color: ${color}">${t(label)}</label>
                </div>
              </div>`;
              }
            }
            return '';
          }
        },
      });
    } else {
      const area = new Area(container.current, {
        height: isSubGroup ? 280 : 230,
        data,
        line: false,
        xField: 'date',
        yField: 'Score',
        point: {
          color: '#2E90FA',
          shape: 'round',
          size: 2
        },
        xAxis: {
          range: [0.01, 0.99],
          label: false,
        },
        yAxis: {
          max: 5,
          range: [0.01, 0.99],
        },
        tooltip: {
          showTitle: false,
          formatter: (datum) => {
            return { name: moment(datum.date).format('YYYY-MM-DD'), value: datum.Score };
          },
          customContent: (title, data) => {
            if (Array.isArray(data)) {
              const item = data[0];
              if (item && item.data) {
                const { Score, date } = item.data;
                const rounded = Math.round(Score);
                const label = labelsNoTranslation[rounded];
                const color = colors[rounded];

                return `<div class="custom-risk-trend-tooltip">
                <div class="cont">
                  <label>${moment(date).format('DD MMM YYYY')}</label>
                </div>
                <div class="cont">
                  <div class="round-score" style="background: ${color}">
                    <label>${Number(Score).toFixed(1)}</label>
                  </div>
                </div>
                <div class="cont">
                  <label class="label" style="color: ${color}">${t(label)}</label>
                </div>
              </div>`;
              }
            }
            return '';
          }
        },
        areaStyle: (datum) => {
          let fill = `l(270) ${getRiskGradient(roundScore)}`;
          return {
            fill,
          };
        },
      });
      area.render();
      setMainGraph(area);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [container, data, t]);

  return (
    <RiskTrendStyle
      className="riskProfile risk-widget"
      style={{
        width: isSubGroup && 'calc(100% / 2 - 8px)',
        paddingBottom: isSubGroup ? 40 : 22,
      }}
    >
      <div className="title">
        {isSubGroup ? (
          <div className="filter-with-select">
            <div className="main-cont">
              <h1
                className="risk-h1"
                style={{ fontSize: isSubGroup && 20 }}
              >
                {i18next.t('Risk Trend')}
              </h1>
            </div>
          </div>
        ) : (
          <div>
            <GetIcon icon="folder-chart" type="line" />
            <h1
              style={{ fontSize: isSubGroup && 20 }}
              className="risk-h1"
            >
              {i18next.t('Trend')}
            </h1>
          </div>
        )}
      </div>
      <div className="graph-cont" ref={container}></div>
    </RiskTrendStyle>
  );
}
